/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const es_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const de_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const nl_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const fr_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const it_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const pt_br2_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const pt_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const ja_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

const zh_pie_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome,63
Safari,20
Edge,5`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_placeholder", locale)
	if (locale === "en") return en_pie_placeholder(inputs)
	if (locale === "es") return es_pie_placeholder(inputs)
	if (locale === "de") return de_pie_placeholder(inputs)
	if (locale === "nl") return nl_pie_placeholder(inputs)
	if (locale === "fr") return fr_pie_placeholder(inputs)
	if (locale === "it") return it_pie_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_pie_placeholder(inputs)
	if (locale === "pt") return pt_pie_placeholder(inputs)
	if (locale === "ja") return ja_pie_placeholder(inputs)
	return zh_pie_placeholder(inputs)
};